import styled from 'styled-components';
import IconButton from '../IconButton/IconButton';

export type HoverState = 'accept' | 'reject';

export const BrowseLink = styled.span`
  color: ${({ theme }) => theme.basePalette.primary.engineBlue};
  text-decoration: underline;
`;

export const CloseButton = styled(IconButton)`
  height: 24px;
  width: 24px;
`;

export const EmptyRoot = styled.div<{ $hover?: HoverState }>`
  align-items: center;
  border-radius: ${({ theme }) => theme.muiBorderRadius.lg};
  color: ${({ theme }) => theme.basePalette.greyscale[70]};
  cursor: pointer;
  display: grid;
  gap: 6px;
  justify-content: center;
  padding: 20px;
  position: relative;

  * {
    /*
    Child elements will generate extraneous dragleave/dragover events that
    bubble when the user moves dragged files over them. This silences them so
    that we only get those events on the main container.
    */
    pointer-events: none;
  }

  ${(props) =>
    props.$hover === 'accept' &&
    `
    background-color: ${props.theme.basePalette.primary.purple};
    color: ${props.theme.basePalette.greyscale.white};
  `}

  ${(props) =>
    props.$hover === 'reject' &&
    `
    border-color: ${props.theme.basePalette.secondary.error};
  `}
`;

export const EmptyRootBorderSvg = styled.svg<{ $hover?: HoverState }>`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  rect {
    fill: none;
    height: calc(100% - 4px);
    stroke: ${(props) =>
      props.$hover === 'reject' ? props.theme.basePalette.secondary.error : props.theme.basePalette.primary.purple};
    stroke-dasharray: 6;
    stroke-width: 2px;
    width: calc(100% - 4px);
  }
`;

export const FileName = styled.span`
  font-size: ${({ theme }) => theme.fontSizesUpdated.md};
  color: ${({ theme }) => theme.basePalette.greyscale['70']};
`;

export const MainPrompt = styled.div<{ $hover?: HoverState }>`
  font-size: ${({ theme }) => theme.fontSizesUpdated.md};
  font-weight: 600;
  text-align: center;

  ${(props) =>
    props.$hover === 'reject' &&
    `
    color: ${props.theme.basePalette.secondary.error};
  `}
`;

export const Prompt = styled.div<{ $size: 'small' | 'large' }>`
  font-size: ${(props) =>
    props.$size === 'small' ? props.theme.fontSizesUpdated.xs : props.theme.fontSizesUpdated.sm};
  line-height: 18px;
  text-align: center;
`;

export const ThumbnailLabel = styled.label`
  align-items: center;
  display: flex;
  gap: 15px;
  flex-grow: 1;
`;

export const ThumbnailRoot = styled.div`
  align-items: center;
  height: 75px;
  background-color: ${({ theme }) => theme.basePalette.greyscale['10']};
  border-radius: ${({ theme }) => theme.muiBorderRadius.lg};
  display: grid;
  gap: 15px;
  grid-template-columns: 1fr auto;
  padding: 6px;
`;

export const ThumbnailFrame = styled.div`
  border-radius: ${({ theme }) => theme.muiBorderRadius.lg};
  height: 64px;
  overflow: hidden;
  width: 64px;

  & img {
    height: 100%;
  }
`;

export const UploadIcon = styled.div<{ $hover?: HoverState }>`
  text-align: center;
  color: ${({ theme }) => theme.basePalette.primary.purple};

  & svg {
    height: auto;
    width: 40px;
  }

  ${(props) =>
    props.$hover === 'accept' &&
    `
    color: ${props.theme.basePalette.greyscale.white};
  `}

  ${(props) =>
    props.$hover === 'reject' &&
    `
    color: ${props.theme.basePalette.secondary.error};
  `}
`;
